enum EventType {
  ABS,
  ABSStop,
  Accident,
  CameraEvent,
  DefectReported,
  DoorClose,
  DoorOpen,
  DriverLogoff,
  DriverLogon,
  Generic,
  HarshBraking,
  HarshCornerLeft,
  HarshCornerRight,
  Idle,
  IgnitionOff,
  IgnitionOn,
  InspectionSubmitted,
  LocationEntered,
  LocationExited,
  LocationTimeout,
  ROP,
  SpeedingStart,
  SpeedingStop,
  TrailerAttached,
  TrailerDetached,
  UnrestrainedDriving,
  VDC,
}

export default EventType;
